"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleProcessor = void 0;
var SimpleProcessor = /** @class */ (function () {
    function SimpleProcessor(collectionNameBuilder, documentBuilder) {
        this.collectionNameBuilder = collectionNameBuilder;
        this.documentBuilder = documentBuilder;
    }
    SimpleProcessor.prototype.process = function (items, batch) {
        var updates = [];
        if (items) {
            for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
                var item = items_1[_i];
                var document = this.documentBuilder(item, batch.block, batch.confirmed, batch.chainId);
                updates.push({
                    collectionName: this.collectionNameBuilder.build(batch.tag),
                    document: document,
                });
            }
        }
        return updates;
    };
    return SimpleProcessor;
}());
exports.SimpleProcessor = SimpleProcessor;
//# sourceMappingURL=SimpleProcessor.js.map